















import { ItemDeRomaneio, ItemDeRomaneioListagem } from '@/models/Romaneio'
import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class DialogoDeDetalhesDaTransferencia extends Vue {
	mostra = false
	itens: ItemDeRomaneioListagem[] = []

	headers = [
		{ text: 'Nome', value: 'nome' },
		{ text: 'SKU', value: 'sku' },
		{ text: 'EAN', value: 'ean' },
		{ text: 'Quantidade', value: 'quantidade' },
	]


	async created() {
		this.itens = []
	}

	async mostrar(item: ItemDeRomaneio[]) {
		this.itens = []
		item.forEach(i => {
			if (this.itens.length < item.length)
				this.itens.push({
					nome: i.produto.nome,
					sku: i.produto.sku || '',
					ean: i.produto.eans[0],
					quantidade: i.quantidade,
				})
		})
		this.mostra = true
	}

	get itensFormatados() {
		return this.itens
	}
}
